import React from "react";

interface NoHoldingsSVGProps {
  size?: string;
}

export default function NoHoldingsSVG({ size }: NoHoldingsSVGProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? "174"}
      height={size ?? "174"}
      viewBox="0 0 174 174"
      fill="none">
      <g opacity=".2">
        <mask id="7paq8f4jya" fill="#fff">
          <path d="M173.5 86.75c0 47.911-38.839 86.75-86.75 86.75C38.84 173.5 0 134.661 0 86.75 0 38.84 38.84 0 86.75 0c47.911 0 86.75 38.84 86.75 86.75zm-108.645 0c0 12.092 9.803 21.895 21.895 21.895 12.092 0 21.895-9.803 21.895-21.895 0-12.092-9.803-21.895-21.895-21.895-12.092 0-21.895 9.803-21.895 21.895z" />
        </mask>
        <path
          d="M173.5 86.75c0 47.911-38.839 86.75-86.75 86.75C38.84 173.5 0 134.661 0 86.75 0 38.84 38.84 0 86.75 0c47.911 0 86.75 38.84 86.75 86.75zm-108.645 0c0 12.092 9.803 21.895 21.895 21.895 12.092 0 21.895-9.803 21.895-21.895 0-12.092-9.803-21.895-21.895-21.895-12.092 0-21.895 9.803-21.895 21.895z"
          fill="#7B858B"
          stroke="#fff"
          strokeWidth="4"
          mask="url(#7paq8f4jya)"
        />
        <mask id="g84xb56bgb" fill="#fff">
          <path d="M142.881 153.104a86.746 86.746 0 0 1-95.8 10.666A86.747 86.747 0 0 1 .568 79.345l64.618 5.536a21.896 21.896 0 0 0 35.919 18.616l41.777 49.607z" />
        </mask>
        <path
          d="M142.881 153.104a86.746 86.746 0 0 1-95.8 10.666A86.747 86.747 0 0 1 .568 79.345l64.618 5.536a21.896 21.896 0 0 0 35.919 18.616l41.777 49.607z"
          fill="#1F2123"
          stroke="#fff"
          strokeWidth="4"
          mask="url(#g84xb56bgb)"
        />
        <mask id="8h7yg1d19c" fill="#fff">
          <path d="M.583 79.157a86.75 86.75 0 0 1 30.68-58.882l41.67 49.697a21.897 21.897 0 0 0-7.744 14.862L.583 79.157z" />
        </mask>
        <path
          d="M.583 79.157a86.75 86.75 0 0 1 30.68-58.882l41.67 49.697a21.897 21.897 0 0 0-7.744 14.862L.583 79.157z"
          fill="#D1D4D6"
          stroke="#fff"
          strokeWidth="4"
          mask="url(#8h7yg1d19c)"
        />
        <mask id="rk5bk6l8yd" fill="#fff">
          <path d="M30.396 21.012A86.75 86.75 0 0 1 59.156 4.59l20.817 61.423a21.895 21.895 0 0 0-7.26 4.145L30.397 21.011z" />
        </mask>
        <path
          d="M30.396 21.012A86.75 86.75 0 0 1 59.156 4.59l20.817 61.423a21.895 21.895 0 0 0-7.26 4.145L30.397 21.011z"
          fill="#E5E7E8"
          stroke="#fff"
          strokeWidth="4"
          mask="url(#rk5bk6l8yd)"
        />
      </g>
      <path
        d="M138.93 116.027c2.687 0 4.865-2.166 4.865-4.838s-2.178-4.838-4.865-4.838c-2.688 0-4.866 2.166-4.866 4.838s2.178 4.838 4.866 4.838z"
        fill="#2F2E41"
      />
      <path d="M129.938 165.882h-1.988l-.946-7.626h2.935l-.001 7.626z" fill="#FEDBDB" />
      <path
        d="M126.53 165.317h3.834v2.401h-6.249a2.4 2.4 0 0 1 1.491-2.218c.292-.121.606-.183.924-.183z"
        fill="#2F2E41"
      />
      <path d="M145.347 165.882h-1.989l-.946-7.626h2.935v7.626z" fill="#FEDBDB" />
      <path
        d="M141.938 165.317h3.835v2.401h-6.25a2.397 2.397 0 0 1 1.491-2.218 2.42 2.42 0 0 1 .924-.183z"
        fill="#2F2E41"
      />
      <path
        d="M138.19 116.055c2.2 0 3.984-1.773 3.984-3.961 0-2.187-1.784-3.961-3.984-3.961s-3.983 1.774-3.983 3.961c0 2.188 1.783 3.961 3.983 3.961z"
        fill="#FEDBDB"
      />
      <path
        d="m140.565 128.834 1.782-4.072a5.035 5.035 0 0 0 .355-3.049 5.059 5.059 0 0 0-1.482-2.693 5.222 5.222 0 0 0-.498-.43 5.04 5.04 0 0 0-3.08-1.06 5.24 5.24 0 0 0-2.173.481c-.059.026-.116.053-.174.08a5.13 5.13 0 0 0-2.064 1.795 5.104 5.104 0 0 0-.812 2.228l-.786 6.554c-.198.514-7.257 19.093-4.788 33.277a.727.727 0 0 0 .619.592l2.503.338a.725.725 0 0 0 .813-.569l4.199-19.903a.565.565 0 0 1 .537-.448.57.57 0 0 1 .566.411l5.933 20.93a.718.718 0 0 0 .699.529.747.747 0 0 0 .141-.013l3.057-.585a.719.719 0 0 0 .589-.776c-.449-4.981-2.837-29.935-5.936-33.617z"
        fill="#2F2E41"
      />
      <path
        d="M122.709 115.391a1.61 1.61 0 0 0 .435 1.302 1.63 1.63 0 0 0 1.283.504l2.227 5.321 1.684-2.482-2.372-4.673a1.631 1.631 0 0 0-1.641-1.424 1.643 1.643 0 0 0-1.085.42 1.63 1.63 0 0 0-.531 1.032zM137.969 134.191a1.631 1.631 0 0 0 1.173-.724 1.608 1.608 0 0 0 .194-1.358l4.685-3.393-2.821-1.05-4.016 3.383a1.63 1.63 0 0 0-1.011 1.918 1.634 1.634 0 0 0 1.796 1.224z"
        fill="#FEDBDB"
      />
      <path
        d="M130.332 126.066a2.821 2.821 0 0 1-.535-.053 2.652 2.652 0 0 1-1.938-1.551l-3.119-3.782a.726.726 0 0 1-.042-.865.728.728 0 0 1 .222-.213l2.219-1.366a.734.734 0 0 1 1.008.241l2.199 3.602 4.211-3.095a1.587 1.587 0 0 1 2.007.467 1.56 1.56 0 0 1-.173 2.043l-4.203 3.812a2.642 2.642 0 0 1-1.856.76zM141.71 131.754h-.017a.739.739 0 0 1-.537-.253l-1.974-2.289a.731.731 0 0 1-.169-.572.732.732 0 0 1 .319-.505l3.695-2.449-3.348-4.001a1.566 1.566 0 0 1 1.395-2.374c.378.01.74.155 1.02.409l4.068 3.953a2.656 2.656 0 0 1-.596 4.345l-3.325 3.508a.736.736 0 0 1-.531.228z"
        fill="#2F2E41"
      />
      <path
        d="M137.177 123.32a.742.742 0 0 1-.468-.166.717.717 0 0 1-.228-.335l-1.483-4.521a.497.497 0 0 1 .259-.6l.048-.023.131-.061a5.313 5.313 0 0 1 2.206-.487 5.1 5.1 0 0 1 2.783.832.503.503 0 0 1 .147.692l-2.782 4.333a.724.724 0 0 1-.613.336z"
        fill="#E6E6E6"
      />
      <path
        d="M142.766 109.029c.879 0 1.592-.709 1.592-1.583 0-.875-.713-1.583-1.592-1.583-.879 0-1.592.708-1.592 1.583 0 .874.713 1.583 1.592 1.583z"
        fill="#2F2E41"
      />
      <path
        d="M137.308 105.706a4.226 4.226 0 0 0-2.982 1.228 4.18 4.18 0 0 0-1.235 2.965v1.774h2.194l1.05-1.774.314 1.774h6.66l-1.784-1.774a4.184 4.184 0 0 0-1.235-2.965 4.228 4.228 0 0 0-2.982-1.228zM143.584 106.361a2.448 2.448 0 0 1 1.03-1.322 2.465 2.465 0 0 1 1.643-.354c1.015.168 1.817.979 2.295 1.885s.699 1.92 1.02 2.892c.322.971.777 1.948 1.589 2.577.811.629 2.056.8 2.853.153a3.237 3.237 0 0 1-.864 1.798 3.28 3.28 0 0 1-3.745.713 3.255 3.255 0 0 1-1.47-1.353c-.42-.744-.529-1.615-.654-2.46-.124-.844-.286-1.717-.788-2.409-.502-.692-1.442-1.144-2.239-.829l-.67-1.291z"
        fill="#2F2E41"
      />
    </svg>
  );
}
